<style src="./Queue.scss" lang="scss"></style>

<template lang="pug">
  section.queue(
    v-esc='close'
  )
    header.queue__header
      h2.queue__title {{ $l10n("QUEUE") }}

      .queue__tools
        .queue__context-menu
          ContextMenu(
            :list='contextMenu'
            color='black'
            mode='bordered'
          )
        button.queue__close(
          @click='close'
          :area-label='$l10n("CLOSE")'
        )
          Icon(
            name='close'
          )
    .queue__body
      ul.queue__list(
        v-if='playlistTracks.length'
      )
        li.queue__item(
          v-for='(track, index) in playlistTracks'
          :style='`z-index: ${playlistTracks.length - index}`'
        ) 
          Track(
            :track='track'
            :tracklist='playlist'
            :in-queue='true'
            :type='"list"'
            :index='index'
          )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Icon from "@/components/Icon/Icon";
import Track from "@/components/Track/Track";
import ContextMenu from "@/components/ContextMenu/ContextMenu";

export default {
  components: {
    Icon,
    Track,
    ContextMenu
  },
  computed: {
    ...mapGetters({
      playlist: "player/playlist",
      tracks: "tracks/tracks"
    }),
    playlistTracks() {
      return this.playlist
        ? this.playlist.tracks.map(track => this.tracks[track])
        : [];
    },
    contextMenu() {
      return this.$contextMenu.create({
        createPlaylist: {
          tracks: this.playlist.tracks
        },
        clearQueue: {
          player: this.$player
        }
      });
    }
  },
  watch: {
    playlistTracks() {
      if (!this.playlistTracks.length) {
        this.close();
      }
    }
  },
  methods: {
    ...mapActions({
      close: "page/closeQueue"
    })
  }
};
</script>
